import { useRef } from "react";
import { get, find } from "lodash";
import { Message } from "primereact/message";
import { BreadCrumb } from "primereact/breadcrumb";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { FilterTags } from "components/FilterTags";
import { Link } from "react-router-dom";
import { PageRequestError } from "components/PageRequestError";
import { Paginator } from "primereact/paginator";
import { Title } from "components/Title";
import useAuth from "hooks/useAuth";
import useApp from "hooks/useApp";
import { useNavigate } from "react-router-dom";
import useListPage from "hooks/useListPage";
import usePostForm from "hooks/usePostForm";
import ImportFile from "./ImportFile";
import { useEffect, useState } from "react";
import CustomDataTable from "components/CustomDataTable";
import { useTranslation } from "react-i18next";
const ModulesListPage = (props) => {
  const [load, setLoad] = useState(false);
  const auth = useAuth();
  const app = useApp();
  const toastRef = useRef(null);
  const navigate = useNavigate();
  const [importModal, setImportModal] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState([]);
  const [uploading, setUploading] = useState(false);
  const { t } = useTranslation();
  const CANCEL = t("CANCEL");
  const MODULE = t("MODULE");
  const IMPORT_MODULE = t("IMPORT_MODULE");
  const SELECT_FACILITY = t("SELECT_FACILITY");
  const CREATE_NEW_MODULE = t("CREATE_NEW_MODULE");
  const MODULE_NAME = t("MODULE_NAME");
  const FACILITIES = t("FACILITIES");
  const CODE = t("CODE");
  const MODULE_ORDER = t("MODULE_ORDER");
  const filterSchema = {
    search: {
      tagTitle: "Search",
      value: "",
      valueType: "single",
      options: [],
    },
  };
  const pageController = useListPage(props, filterSchema, "data");
  const { isLicenseKeyValid, validateLicense } = usePostForm({});
  const filterController = pageController.filterController;
  const {
    records,
    pageReady,
    loading,
    selectedItems,
    sortBy,
    sortOrder,
    apiRequestError,
    setSelectedItems,
    getPageBreadCrumbs,
    onSort,
    deleteItem,
    pagination,
    refetch,
  } = pageController;
  const {} = filterController;
  const {
    totalRecords,
    totalPages,
    recordsPosition,
    firstRow,
    limit,
    onPageChange,
  } = pagination;

  function IdTemplate(data) {
    if (data) {
      return <Link to={`/modules/view/${data.id}`}> {data.id}</Link>;
    }
  }
  const handleRowClick = (event) => {
    const rowData = event.data;
    navigate(`/modules/view/${rowData.id}`);
  };
  function OrganisationTemplate(data) {
    let orgName = "-";
    if (data && props.organisations.length > 0) {
      const org = find(
        props.organisations,
        (org) => get(org, "code") === get(data, "org_code", null)
      );
      orgName = org ? get(org, "name", "-") : "-";
    }
    return orgName;
  }

  const findOrgByCode = (orgCode) => {
    const org =
      find(props.organisations, (org) => get(org, "code") === orgCode) || {};
    return org ? get(org, "name", "-") : "-";
  };

  function EmptyRecordMessage() {
    if (pageReady && !records.length) {
      return (
        <div className="text-lg mt-3 p-3 text-center text-400 font-bold">
          {t("NO_MODULES_FOUND")}
        </div>
      );
    }
  }

  function PagerControl() {
    setLoad(true);
    if (props.paginate && totalPages > 1) {
      const pagerReportTemplate = {
        layout: pagination.layout,
        CurrentPageReport: (options) => {
          return (
            <>
              <span className="text-sm text-gray-500 px-2">
                {MODULE}{" "}
                <b>
                  {recordsPosition} {t("OF")} {options.totalRecords}
                </b>
              </span>
            </>
          );
        },
      };
      return (
        <div className="flex-grow-1">
          <Paginator
            first={firstRow}
            rows={limit}
            totalRecords={totalRecords}
            onPageChange={onPageChange}
            template={pagerReportTemplate}
          />
        </div>
      );
    }
    setLoad(false);
  }
  function PageFooter() {
    if (pageReady && props.showFooter) {
      return (
        <div className="flex flex-wrap justify-content-between">
          <PagerControl />
        </div>
      );
    }
  }
  function PageBreadcrumbs() {
    if (props.showBreadcrumbs) {
      const items = getPageBreadCrumbs();
      return items.length > 0 && <BreadCrumb className="mb-3" model={items} />;
    }
  }

  useEffect(() => {
    validateLicense(null, "module");
  }, []);

  const footerContent = (
    <div className="flex gap-2">
      <Button
        label={CANCEL}
        icon="pi pi-times"
        onClick={() => {
          setSelectedOrg({});
          setImportModal(false);
        }}
        className="p-button bg-primary"
        disabled={uploading}
      />
      <ImportFile
        toastRef={toastRef}
        setImportModal={setImportModal}
        label={IMPORT_MODULE}
        onUploadStart={() => setUploading(true)}
        onUploadEnd={() => {
          setUploading(false);
          app.getAllModules();
          refetch();
        }}
        url={`modules/import_module/${selectedOrg?.code}`}
        accept="/\.(hm)$/i"
        disabled={!selectedOrg?.code}
      />
    </div>
  );

  if (apiRequestError) {
    return <PageRequestError error={apiRequestError} />;
  }
  return (
    <main id="ModulesListPage" className="main-page">
      <Toast ref={toastRef} />
      {props.showHeader && (
        <section className="page-section mb-3">
          <div className="container-fluid">
            <Dialog
              header={IMPORT_MODULE}
              visible={importModal}
              onHide={() => {
                setSelectedOrg({});
                setImportModal(false);
              }}
              footer={footerContent}
              position="top"
            >
              <Dropdown
                value={selectedOrg}
                onChange={(e) => setSelectedOrg(e.value)}
                options={(auth?.user?.orgs || []).map((val) => ({
                  name: findOrgByCode(val),
                  code: val,
                }))}
                optionLabel="name"
                placeholder={SELECT_FACILITY}
                filter
                className="w-full"
                disabled={uploading}
                showClear
              />
              {!(auth?.user?.orgs || []).length && (
                <Message
                  severity="info"
                  className="mt-3"
                  text={t("TEXT_LIST")}
                />
              )}
              {uploading ? "Uploading..." : ""}
            </Dialog>
            <div className="flex justify-content-between align-items-center">
              <Title
                title={MODULE}
                titleClass="text-2xl text-primary font-bold"
                subTitleClass="text-500"
                separator={false}
              />
              <div className="flex gap-3 align-items-center">
                {["Admin", "Super Admin"].includes(auth.user.roleName) && (
                  <Button
                    label={IMPORT_MODULE}
                    icon="pi pi-plus"
                    type="button"
                    className="p-button-primary"
                    disabled={!isLicenseKeyValid}
                    tooltip={
                      !isLicenseKeyValid
                        ? t("PLEASE_UPGRADE_LISENSE_TOIMPORT_MORE_MODULES")
                        : ""
                    }
                    onClick={() => setImportModal(true)}
                    tooltipOptions={{
                      showOnDisabled: true,
                      position: "left",
                    }}
                  />
                )}
                {auth.user.roleName === "Super Admin" && (
                  <Button
                    label={CREATE_NEW_MODULE}
                    icon="pi pi-plus"
                    type="button"
                    className="p-button-primary"
                    disabled={!isLicenseKeyValid}
                    tooltip={
                      !isLicenseKeyValid
                        ? t("PLEASE_UPGRADE_LISENSE_TOCREATE_MORE_MODULES")
                        : ""
                    }
                    tooltipOptions={{
                      showOnDisabled: true,
                      position: "left",
                    }}
                    onClick={() => navigate("/modules/add")}
                  />
                )}
              </div>
            </div>
          </div>
        </section>
      )}
      <section className="page-section ">
        <div className="container-fluid">
          <div className="grid ">
            <div className="col comp-grid">
              <FilterTags filterController={filterController} />
              <div>
                <PageBreadcrumbs />
                <div className="page-records">
                  <CustomDataTable
                    loading={loading}
                    data={records}
                    selectionMode="checkbox"
                    selectedItems=""
                    onSelectionChange={(e) => setSelectedItems(e.value)}
                    sortField={sortBy}
                    sortOrder={sortOrder}
                    onSort={onSort}
                    rowClickHandler={handleRowClick}
                    emptyMessage={<EmptyRecordMessage />}
                    columns={[
                      { field: "id", header: "Id", body: IdTemplate },
                      { field: "module_name", header: MODULE_NAME },
                      {
                        field: "org_code",
                        header: FACILITIES,
                        body: OrganisationTemplate,
                      },
                      { field: "code", header: CODE },
                      { field: "module_order", header: MODULE_ORDER },
                    ]}
                  />
                </div>
                <PageFooter />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
const withDefaultProps = (Component) => {
  const WrappedComponent = (props) => {
    const { t } = useTranslation();
    const defaultProps = {
      primaryKey: "id",
      pageName: "modules",
      apiPath: "modules/get_all_modules",
      filterApiPath: "modules/get_modules_by_org",
      routeName: "moduleslist",
      msgBeforeDelete: t("ARE_YOU_SURE_TO_DELETE_MODULE"),
      msgTitle: t("DELETE_MODULE"),
      msgAfterDelete: t("MODULE_DELETED_SUCCESSFULLY"),
      showHeader: true,
      showFooter: true,
      paginate: true,
      isSubPage: false,
      showBreadcrumbs: true,
      exportData: false,
      importData: false,
      keepRecords: false,
      multiCheckbox: true,
      search: "",
      fieldName: null,
      fieldValue: null,
      sortField: "id",
      sortDir: "asc",
      pageNo: 1,
      limit: 10,
    };
    return <Component {...defaultProps} {...props} />;
  };

  return WrappedComponent;
};
export default withDefaultProps(ModulesListPage);
